<template>
    <ModalDialogContainer ref="modalContainer" v-model:display="displayStatus">
        <div class="modal-dialog modal-lg" role="document" @click="stopPropagationEvent">
            <div class="modal-header">
                <div class="modal-title">{{ $t("Attestation") }}</div>
                <button type="button" class="modal-close-btn" :title="$t('Close')" @click="close">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            <div class="modal-body no-padding">
                <div class="table-responsive" v-if="attestation">
                    <table class="table">
                        <tr>
                            <td class="bold on-line">{{ $t("Attestation type") }}</td>
                            <td class="bold">{{ renderAttestationType(attestation.type) }}</td>
                        </tr>

                        <tr>
                            <td class="bold on-line">{{ $t("Attestator") }} ({{ $t("ID") }})</td>
                            <td>{{ attestation.attestator || "-" }}</td>
                        </tr>

                        <tr>
                            <td class="bold on-line">{{ $t("Attestator") }} ({{ $t("Name") }})</td>
                            <td>{{ attestation.attestatorName || "-" }}</td>
                        </tr>

                        <tr>
                            <td class="bold on-line">{{ $t("Subject") }} ({{ $t("ID") }})</td>
                            <td>{{ subject || "-" }}</td>
                        </tr>

                        <tr>
                            <td class="bold on-line">{{ $t("Subject") }} ({{ $t("Name") }})</td>
                            <td>{{ subjectName || "-" }}</td>
                        </tr>

                        <tr>
                            <td class="bold on-line">{{ $t("Expiration date") }}</td>
                            <td>{{ renderDateAndTime(attestation.expiration, $t) }}</td>
                        </tr>

                        <tr v-for="(a, i) in attestation.attributes" :key="i">
                            <td class="bold">{{ $t("Attribute") }}: {{ a.name }}</td>
                            <td>{{ a.value }}</td>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <CodeBlock :language="'raw'" :code="attestation.raw" :name="$t('Raw attestation')"></CodeBlock>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-mr" @click="close"><i class="fas fa-check"></i> {{ $t("Done") }}</button>
            </div>
        </div>
    </ModalDialogContainer>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { useVModel } from "../../utils/v-model";
import { DataSpaceKnownParticipantAttestation } from "@/api/definitions";
import CodeBlock from "../utils/CodeBlock.vue";
import { renderDateAndTime } from "@/utils/time-utils";

export default defineComponent({
    components: {
        CodeBlock,
    },
    name: "AttestationViewModal",
    emits: ["update:display"],
    props: {
        display: Boolean,
        attestation: Object as PropType<DataSpaceKnownParticipantAttestation>,
        subject: String,
        subjectName: String,
    },
    setup(props) {
        return {
            displayStatus: useVModel(props, "display"),
        };
    },
    data: function () {
        return {};
    },
    methods: {
        close: function () {
            this.$closeModal();
        },

        escapeToClose: function (event) {
            if (event.key === "Escape") {
                this.close();
            }
        },

        stopPropagationEvent: function (e) {
            e.stopPropagation();
        },

        renderAttestationType: function (type: string) {
            switch (type) {
                case "x509":
                    return this.$t("X.509 Signed Certificate");
                case "did-jwt":
                    return this.$t("JWT DID Attestation");
                default:
                    return "-";
            }
        },

        renderDateAndTime: renderDateAndTime,
    },
    mounted: function () {
        if (this.display) {
            this.$autoFocus();
        }
    },
    beforeUnmount: function () {},
    watch: {
        display: function () {
            if (this.display) {
                this.$autoFocus();
            }
        },
    },
});
</script>

<style></style>
